document.addEventListener('DOMContentLoaded', function() {
  const signature = document.querySelector("#signature");
  if (!signature) return;

  const isMobile = window.innerWidth <= 769;

  const paths = document.querySelectorAll(".st3");
  const pathLengths = [];

  paths.forEach(path => {
    const length = path.getTotalLength();
    pathLengths.push(length);
    path.style.strokeDasharray = length;
    path.style.strokeDashoffset = length;
    path.style.opacity = 1;
  });

  if (isMobile) {
    let delay = 0;
    paths.forEach((path, i) => {
      const length = pathLengths[i];
      path.style.transition = `stroke-dashoffset ${length / 3000}s ease-out ${delay}s`;
      path.style.strokeDashoffset = 0;
      delay += length / 3000;
    });
    return;
  }

  const signatureWrapper = document.querySelector(".signature-wrapper");
  const scrollHeight = signature.getBoundingClientRect().height - signatureWrapper.getBoundingClientRect().height;

  window.addEventListener("scroll", function () {
    const scrollY = window.scrollY;
    let scrolledRatio = scrollY / scrollHeight;
    if (scrolledRatio > 1) scrolledRatio = 1;
    if (scrolledRatio < 0) scrolledRatio = 0;

    let accumulatedLength = 0;
    for (let i = 0; i < paths.length; i++) {
      const path = paths[i];
      const pathLength = pathLengths[i];
      const pathStart = accumulatedLength;
      const pathEnd = accumulatedLength + pathLength;

      let dashoffset = pathLength;
      if (scrolledRatio * totalPathLength > pathStart) {
        const drawAmount = (scrolledRatio * totalPathLength) - pathStart;
        dashoffset = pathLength - drawAmount;
        if (dashoffset < 0) dashoffset = 0;
      }
      
      path.style.strokeDashoffset = dashoffset;
      accumulatedLength += pathLength;
    }
  });

  const totalPathLength = pathLengths.reduce((sum, length) => sum + length, 0);
});
